import { UtilityNavigationItem } from './models/utility-import.models';

export const UTILITY_REGISTRY: ReadonlyArray<UtilityNavigationItem> = [
  {
    key: 'data-imports',
    title: 'Data imports',
    description: 'Validate and commit controlled raw-data imports with a complete audit trail.',
    route: '/dashboard/utilities/imports',
    icon: 'upload_file',
    requiredCapability: 'canView',
    category: 'imports'
  }
];
